<template>
  <a-config-provider :locale="locale">
    <router-view/>
  </a-config-provider>
</template>
<script>
import zhCN from 'ant-design-vue/es/locale/zh_CN'

export default {
  data () {
    return {
      locale: zhCN
    }
  }
}
</script>
<style lang="less">
* {
  margin: 0; padding: 0;
}
html, body {
  min-height: 100%;
  p {
    margin: 0;
  }
}
ul {
  margin: 0; padding: 0;
  li {
    list-style: none;
  }
}
// 段落标题
.paragraph-title {
  font-size: 18px; font-weight: bold;
}
#app {
  height: 100%; font-size: 14px;
  background: #F7F7F7;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>
